<template>
    <div>
        <div v-if="newCase" class="cases-material cases-material-new" v-html="material" />
        <article v-else class="cases-material" v-html="material" />
    </div>
</template>

<script>
export default {
    props: ['material', 'newCase'],


    mounted () {
        // Fix editor bug
        let editables = document.querySelectorAll('[contenteditable="true"]');
        editables.forEach(el => {
            el.setAttribute('contenteditable', false);
        });

        // Add '»' to blockquote text end
        let quotes = this.$el.querySelectorAll('blockquote');
        quotes.forEach(el => {
            el.lastChild.nodeValue = el.lastChild.nodeValue+'»'
        });
    },
}
</script>


